import { selectOptions } from 'constants'
import { useTheme } from 'contexts'
import React from 'react'
import { StyleSheet } from 'react-native'
import * as Yup from 'yup'

import { MyFormValues } from 'partials/EditProfileForm'

import { Box } from 'widgets/Box'
import { Field } from 'widgets/Field'
import { Form } from 'widgets/Form'
import { Text } from 'widgets/Text'

type CityStateFormProps = {
  initialValues: MyFormValues
  onSubmit: (values: any) => void
}

export const CityStateForm = ({ initialValues, onSubmit }: CityStateFormProps) => {
  const theme = useTheme()
  const computedStyles = StyleSheet.create({
    fieldStyles: {
      backgroundColor: 'transparent',
      borderWidth: 1,
      borderColor: theme.colors.greyLight,
      color: 'white',
    },
  })

  return (
    <>
      <Box testID='FormTitle' margin={{ horizontal: 'md' }}>
        <Text color='white'>Where do you live?</Text>
      </Box>
      <Box testID='CityStateForm' margin={{ top: 'sm' }}>
        <Form
          initialValues={initialValues}
          onSubmit={onSubmit}
          submitCopy='NEXT'
          validationSchema={Yup.object().shape({
            city: Yup.string().required('This field is required.'),
            state: Yup.string().required('Please select a state.'),
          })}
        >
          {({ errors: formikErrors, touched }: any) => {
            return (
              <>
                <Field
                  name='city'
                  placeholder='City'
                  placeholderTextColor={theme.colors.greyDarker}
                  style={computedStyles.fieldStyles}
                />
                <Field
                  name='state'
                  placeholder='State'
                  placeholderTextColor={theme.colors.greyDarker}
                  type='select'
                  options={selectOptions.STATE_OPTIONS}
                />
              </>
            )
          }}
        </Form>
      </Box>
    </>
  )
}
